<div *ngIf="alerts.length" >

  <fadv-alert variant="danger"
  open="open"
  closable="closable"
  duration="15000"  >

  <div *ngFor="let alert of alerts" >

    <span [innerHTML]="alert.message"></span>
</div>

</fadv-alert>
<br>
</div>
